import React from 'react'
import { Link } from 'react-router-dom';
const Login = (props) => {
    const {email,setEmail,password,setPassword,handleLogin,handleSignup,hasAccount,setHasAccount,emailError,passwordError}=props;
    
    return ( 
        <section className="login">
            <div className="loginContainer">
                 <label>Username</label>
                 <input
                 type="text"
                 autoFocus
                 required
                 value={email}
                 onChange={(e)=>setEmail(e.target.value)}
                 />
                 <p className="errorMsg">{emailError}</p>
                 <label>Password</label>
                 <input
                 type="password"
                 required
                 value={password}
                 onChange={(e)=>setPassword(e.target.value)}
                 />
                 <p className="errorMsg">{passwordError}</p>
               <div className="btnContainer">
                    {hasAccount ? (
                         <>
                         <button onClick={handleLogin}className="buttonL">Sign In</button>
                         <p> Dont have an account? <span onClick={()=>
                              setHasAccount(!hasAccount)
                         }>Sign up</span></p>

                         </>
                    ):(
                         <>
                         <button component={Link}  to="/products" onClick={handleSignup}className="buttonL">Sign Up</button>
                         <p> Have an account?<span onClick={()=> setHasAccount(!hasAccount)}>Sign in</span></p>
                          </>
                    )}
               </div>

            </div>  
        </section>
     );
}
 
export default Login;